/**
 * Unified geolocation service
 * Tries browser geolocation first, falls back to IP-based
 */

import { requestBrowserLocation } from './browserGeo.js';
import { getLocationByIp } from './ipGeo.js';

export async function requestLocation() {
    try {
        // Try browser geolocation first
        return await requestBrowserLocation();
    } catch (browserError) {
        // Fall back to IP-based geolocation
        try {
            return await getLocationByIp();
        } catch (ipError) {
            return null;
        }
    }
}
